import TeamBlock from "../../Components/TeamWorkout/TeamBlock/TeamBlock";
import VideoBanner from "../../Components/TeamWorkout/VideoBanner/VideoBanner";
import AnthonyImg from "../../Assets/Images/Team/Anthony.png";
import AnthonyImg1 from "../../Assets/Images/Team/Anthony.png";

import t1 from "../../Assets/Images/Team/tt1_v2.png";
import t2 from "../../Assets/Images/Team/tt2_v2.png";
import t3 from "../../Assets/Images/Team/tt3_v2.png";
import t4 from "../../Assets/Images/Team/tt4_v2.png";
import t5 from "../../Assets/Images/Team/tt5_v2.png";
import t6 from "../../Assets/Images/Team/tt6_v2.png";
import t7 from "../../Assets/Images/Team/tt7_v2.png";
import t8 from "../../Assets/Images/Team/tt8_v2.png";
import t9 from "../../Assets/Images/Team/tt9_v2.png";
import t10 from "../../Assets/Images/Team/tt10_v2.png";
import t11 from "../../Assets/Images/Team/tt11_v2.png";
import t12 from "../../Assets/Images/Team/tt12_v2.png";
import t13 from "../../Assets/Images/Team/tt13_v2.png";

import "./teamworkout.css";
import Sponsors from "../../Components/Home/Sponsers/Sponsers";
import StaticPageHeaders from "../../Components/StaticPageHeaders";

import pdf from "../../Assets/Pdf/shootinschoolbookFINAL_sml-1.pdf";
import SEO from "../../Components/SEO";

const team = [
  {
    image: t1,
    name: "BASIM ERZOUKI",
    role: "Head Instructor",
    description:
      "Coach Basim is a basketball trainer with a competitive playing and coaching background. He played varsity basketball at the high school level and spent two years playing college basketball. Following his playing career, Basim coached travel and CYO basketball for three years before becoming a trainer at Shootin School, where he has been developing players for the past year and a half. He takes pride in pushing athletes to be their best while helping them build real confidence, skill, and game understanding.",
  },
  {
    image: t2,
    name: "LOGAN DALY",
    role: "Head Instructor",
    description:
      "Coach Logan has been training with Shootin School since the 2nd grade and played high school basketball at St. Joseph by the Sea. After graduating, he transitioned into a training role with Shootin School, focusing on player development and skill growth. Coach Logan is one of our head clinicians and runs intense and hyper focused workouts for players, small groups, and entire teams. Coach Logan is also a Lead Trainer for Because We Can Sports, an integrated sports program that works with young athletes who have disabilities. He is passionate about teaching and helping athletes of all abilities succeed on and off the court.",
  },
  {
    image: t3,
    name: "JALEN SAYAMAN",
    role: "Head Instructor",
    description:
      "Coach Jalen has been training basketball athletes for the past year and brings with him over a decade of experience playing organized basketball at multiple competitive levels, including CYO, high school, and adult men’s leagues. His extensive background as a player has given him a strong understanding of the game’s fundamentals, advanced concepts, and competitive demands. Jalen is deeply passionate about the sport of basketball and is equally committed to developing players through high-level, intentional training. His enthusiasm for the game, combined with his firsthand playing experience, allows him to connect effectively with athletes and provide instruction that is both technically sound and rooted in real-game application.",
  },
  {
    image: t4,
    name: "FRANK BARBATO",
    role: "Instructor",
    description:
      "Coach Frank is a basketball trainer with an extensive playing and coaching background. He played varsity basketball for two years at the high school level before going on to compete for two years in Division III college basketball level. Following his playing career, Frank has spent over five years training basketball players ranging from high school to collegiate and professional levels. He also brings coaching experience at the high school level and has been immersed in the game of basketball for decades, taking pride in developing skilled, confident, and well-rounded athletes.",
  },
  {
    image: t5,
    name: "ERIC WIESE",
    role: "Instructor",
    description:
      "Coach Eric is a longtime member of the Shootin’ School basketball family, having progressed from trainee to one of our premier trainers. A lifelong player, he has dedicated himself to mastering every aspect of the game while developing the ability to teach and adapt to athletes of all levels. Coach Eric’s passion, experience, and commitment to growth make him an outstanding mentor for players looking to elevate their skills.",
  },
  {
    image: t6,
    name: "VIN DACUNTO",
    role: "Instructor",
    description:
      "Vincent D’Acunto is a travel baseball coach for the Staten Island Orioles and a former coach with the St. Joseph by the Sea Vikings high school program. A graduate of St. Joseph by the Sea, Class of 2020, he was a multi-sport athlete who played both baseball and basketball. He currently specializes in pitching and hitting instruction, working with athletes of all ages to develop strong fundamentals, confidence, and game awareness. In addition to coaching, Vincent is studying Adaptive Physical Education at Brooklyn College, focusing on supporting and empowering children with special needs through inclusive physical activity and sport.",
  },
  {
    image: t7,
    name: "NICO RIVERA",
    role: "Instructor",
    description:
      "Coach Nico has a ton of basketball experience as he’s played cyo and travel basketball along with playing four years of high school basketball. After his playing career, he coached a cyo team and then became apart of the Shootin’ School family. Nico prioritizes hard work and helps kids push themselves to become better every single day. When training with Coach Nico, you know you’re going to put in 100% effort while building confidence to help you execute when it comes to game time.",
  },
  {
    image: t8,
    name: "MADDIE DALY",
    role: "Instructor",
    description:
      "Coach Maddie has been training with Shootin’ School since the age of eight and has proudly served as a coach for the past three years. They played high school basketball at St. Joseph by the Sea High School, where they were named team captain and led the program to a championship victory in 2020. Their long-standing connection to Shootin’ School reflects a deep commitment to player development and the growth of young athletes.",
  },
  {
    image: t9,
    name: "JUSTIN KLAYMAN",
    role: "Instructor",
    description:
      "Coach Justin’s basketball journey began on the courts at a very young age. Then he attended Monsignor Farrell High School, where he played for three seasons, developing a deep love for the game. Although his athletic path shifted when he went on to play college baseball, basketball always remained close to his heart. Having been introduced to the Shooting School at a young age, Justin benefited from expert coaching early on, learning the fundamentals of shooting and skill development that have shaped his approach as a trainer today. His passion for the sport, combined with his understanding of both basketball and baseball, gives him a unique perspective on athletic development, mental toughness, and performance training. Now working at Shootin’ School, Justin brings his years of experience to the court, helping young athletes elevate their game with personalized drills and shooting techniques. He’s committed to not just teaching basketball skills but fostering the same passion for the game that has motivated him throughout his own journey.",
  },
  {
    image: t10,
    name: "TIM COLACCI",
    role: "Instructor",
    description:
      "Coach Tim has been playing the game of basketball for the past 9 years. He played high school basketball while also competing in travel basketball for 4 years, gaining valuable experience at a competitive level. For the past 4 years, Coach Tim has been working with Shootin School, helping develop young athletes and sharing his passion for the game. He has always loved playing basketball and wanted to turn that love into an opportunity to teach and inspire others. Coach Tim is dedicated to helping players improve their skills, build confidence, and gain the same love for the sport that shaped his journey, while pushing them to reach their full potential and be the best they can be.",
  },
  {
    image: t11,
    name: "GIANNA BURNETT",
    role: "Instructor",
    description:
      "Coach Gianna began her basketball journey at just six years old, competing in CYO leagues throughout elementary, middle, and high school. She continued her development at Tottenville High School, playing on the JV team, and gained additional competitive experience through travel basketball with the Lady Musketeers during middle and high school. Beyond playing, she has extensive hands-on coaching experience. She has assisted with youth basketball clinics for Biddies programs and intramural leagues, and served as a coach for Munchkin Mondays, working closely with young athletes at the foundational level of the game. She specializes in coaching beginners and early-developing players. Her coaching style is rooted in positivity, enthusiasm, and encouragement, with a strong focus on celebrating small wins and steady progress. By building confidence early, she helps athletes master essential basketball fundamentals skills that translate to success at every level. Coach Gianna creates a supportive environment where players feel motivated, capable, and excited to grow. ",
  },
  {
    image: t12,
    name: "ADAM HASNAOUI",
    role: "Instructor",
    description:
      "Coach Adam Hasnaoui has over 14 years of high level basketball experience across all 5 boroughs of NYC, aiming to deliver a fundamental based approach ensuring discipline and development within each training session; welcoming players of all players of all age and skill level.",
  },
  {
    image: t13,
    name: "CAMRYN KOCH",
    role: "Instructor",
    description:
      "Coach Camryn has been training athletes in speed, agility, and track and field since 2022, She also coaches youth basketball, including Munchkin Mondays through Shooting School, where she focuses on fundamentals, skill development, and creating a positive, high-energy environment for young athletes. As a track and field athlete, Coach Camryn competed for six years, beginning at the intermediate/middle school level, continuing through varsity high school, and advancing to the NCAA Division II collegiate level. This experience gives her a strong understanding of the physical and mental demands of competitive athletics. Coach Camryn is an adaptable and encouraging coach who tailors training to each athlete to support performance and confidence.",
  },
];

const TeamWorkout = () => {
  return (
    <>
      <SEO
        title="About Shootin School - Shootin School Basketball"
        description=""
        url="https://shootinschool.com/about/"
      />
      <StaticPageHeaders title="About Shootin School" />
      <VideoBanner
        videoUrl="https://www.youtube.com/embed/7RS0kzamySk?si=rl78YPJyYCPvJSyp"
        title="Mission Video"
        heading="Our Mission"
        description="Shootin’ School Basketball’s mission is to teach and develop basketball players of all ages and skill levels offering them the opportunity to learn the skills necessary to take their basketball game to the next level while instilling life-lessons and values such as character, teamwork, discipline, respect, and sportsmanship."
        showLogo={false}
        buttons={[
          { text: "Download Our “About Us” Ebook", linkTo: "/ebook-download" },
        ]}
        buttonText="Download Our “About Us” Ebook"
        buttonLink={pdf}
      />

      <div className="ss-trainer brightness">
        <h2 className="text-clip">Shootin’ School trainers</h2>
      </div>

      {team.map((member, i) => (
        <TeamBlock
          key={i}
          image={member.image}
          name={member.name}
          role={member.role}
          description={member.description}
        />
      ))}

      <div className="ttb-ui brightness">
        <h2 className="text-clip">Triple Threat Basketball</h2>
        <p className="text-clip">Anthony Passalacqua</p>
        <div className="ttb-video">
          <iframe
            src="https://www.youtube.com/embed/7RS0kzamySk?si=52L__H6MTwZYM00Q"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div className="about-sponsors">
        <Sponsors />
      </div>
    </>
  );
};
export default TeamWorkout;
